import { PageContext } from '@contexts/page'
import { SubscriptionFormVisibleContext } from '@contexts/subscription-form-visible'
import { useTrackExternalLink } from '@hooks/use-track-external-link'
import { EnhancedButton } from '@ui/enhanced-components/enhanced-components'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import React, { type SyntheticEvent, useCallback, useContext } from 'react'

export const OpenFormButtonRefresh = () => {
  const { open } = useContext(SubscriptionFormVisibleContext)
  const triggerEventExternalHyperlink = useTrackExternalLink()
  const { form } = useContext(PageContext) || {}
  const hasForm = Boolean(form)
  const onOpenAccountClick = useCallback(
    (event: SyntheticEvent) => {
      open(true)
      triggerEventExternalHyperlink(event)
    },
    [triggerEventExternalHyperlink]
  )

  if (!hasForm) {
    return null
  }

  return (
    <div className="mt-5 flex justify-center laptop:hidden">
      <EnhancedButton
        className="!w-full !max-w-none"
        color="primary"
        data-role={ENHANCED_COMPONENT_ROLE.MOBILE_FORM}
        data-type={ENHANCED_COMPONENT_TYPE.CTA}
        id={ENHANCED_COMPONENT_ROLE.MOBILE_FORM}
        onClick={onOpenAccountClick}
      >
        Ouvrir un compte
      </EnhancedButton>
    </div>
  )
}
